/*
 * @providesModule RegistrationBanner
 */

import React from 'react';
import LinearGradient from 'react-native-linear-gradient';
import Label from 'Label';
import styles from './RegistrationBannerStyles';

interface RegistrationBannerProps {
  text: string;
}

const RegistrationBanner: React.FC<RegistrationBannerProps> = ({text}) => {
  if (!text) {
    return null;
  }

  // Base gradient colors (deep purple)
  const baseGradientColor1 = '#470B82';
  const baseGradientColor2 = '#7826C7';
  const baseGradientColors = [baseGradientColor1, baseGradientColor2, baseGradientColor1];

  // Black overlay
  const overlayColor = 'rgba(0, 0, 0, 0.2)';
  const overlayColors = [overlayColor, overlayColor];

  // Top gradient colors (pink/magenta)
  const topGradientColor1 = 'rgba(255, 8, 251, 0.7)';
  const topGradientColor2 = 'rgba(255, 129, 253, 0.7)';
  const topGradientColor3 = 'rgba(153, 5, 151, 0.7)';
  const topGradientColors = [
    topGradientColor1,
    topGradientColor2,
    topGradientColor1,
    topGradientColor3,
  ];

  return (
    <LinearGradient
      colors={baseGradientColors}
      locations={[0, 0.5, 1]}
      start={{x: 1, y: 0}}
      end={{x: 0, y: 0}}
    >
      <LinearGradient
        colors={topGradientColors}
        locations={[0.1392, 0.3527, 0.6578, 0.8442]}
        start={{x: 0, y: 0.5}}
        end={{x: 1, y: 0.5}}
      >
        <Label style={styles.bannerText} numberOfLines={1}>
          {text}
        </Label>
      </LinearGradient>
    </LinearGradient>
  );
};

export default RegistrationBanner;
